export const SYSTEM_ICON_MAP = {
  AgileAndScrumIcon: "circle-arrow-out-up-right",
  ProjectManagementIcon: "refresh-ccw",
  DevOpsIcon: "infinity",
  ItServiceManagementIcon: "arrow-left-right",
  WindowIcon: "grid-2x2",
  QualityManagementIcon: "circle-check-big",
  SecurityIcon: "shield-check",
  DataAnalyticsIcon: "chart-line",
  UserCheck: "users",
  DigitalMarketingIcon: "rocket",
  LanguageOutlined: "languages",
  LaptopWindowsOutlined: "laptop",
  PhoneIcon: "phone",
  MailIcon: "mail",
  InsightfulAnalyticsIcon: "chart-column-increasing",
  CompetitiveIcon: "trophy",
  WalletIcon: "wallet",
  CommandButton: "command",
  CourseTypeIcon: "book-open",
  NodesOutlined: "maximize-2",
  AwardOutlined: "award",
  CorporateTrainingIcon: "building",
  CallBackIcon: "phone-incoming",
  BulbOutlined: "lightbulb",
  EventsAndWebinarsIcon: "laptop",
  AssignmentThin: "notepad-text",
  ImprovementOutline: "chart-column-increasing",
  ThumbUpOutlined: "thumbs-up",
  AllCoursesIcon: "graduation-cap",
  SoftwareDevelopmentIcon: "monitor-cog",
  HealthcareIcon: "hospital",
  AutomobileIcon: "car",
  FinanceAndBankingIcon: "landmark",
  EducationIcon: "graduation-cap",
  ManufacturingIcon: "cog",
  RetailIcon: "store",
  GovernmentIcon: "landmark",
  SupplyChainIcon: "truck",
  Flash6737345: "zap",
  TrainedIcon: "users",
  ReferralIcon: "hand-coins",
  UserRoundCheckOutline: "user-round-check",
  LightBulbIcon: "lightbulb",
  MissionIcon: "goal",
  DiamondIcon: "hand-helping",
  DigitalTransformationIcon: "cpu",
  ProvenResultIcon: "book-check",
  ContinuousSupportIcon: "headset",
  SalaryOutline: "hand-coins",
  BriefcaseThin: "briefcase-business",
  CareerPrepAndCapstoneProjectIcon: "briefcase",
  IntegrityIcon: "building-2",
  UsersOutline: "users",
  CheckSquare: "square-check-big",
  MarketChangesIcon: "chart-scatter",
  CustomerSatisfactionIcon: "badge-check",
  ScheduleOutlined: "clock-4",
  CulturalTransformationIcon: "route",
  ScalabilityIcon: "scaling",
  RiskMitigationIcon: "triangle-alert",
  ItSecurityIcon: "file-terminal",
  SqlAndNosqlDatabasesIcon: "database",
  PhoneCallbackOutlined: "phone-incoming",
  IntroductionDataAnalyticsIcon: "trending-up",
  UsersRoundOutline: "user-check",
  Globe: "globe",
  Search: "search",
  User: "user",
  Calendar: "calendar",
  Settings: "settings",
  Home: "home",
  UserCheckOutline: "user-check",
  UserCog: "user-cog",
  Ai: "sparkles",
} as const;

// Extracts the keys: "AgileAndScrumIcon" | ...
export type SystemIconName = keyof typeof SYSTEM_ICON_MAP;

// Extracts the values: "circle-arrow-out-up-right" | ...
export type SystemIconValue = (typeof SYSTEM_ICON_MAP)[SystemIconName];

export const getSystemIcon = (name: string): SystemIconValue => {
  return SYSTEM_ICON_MAP[name as SystemIconName] ?? "globe";
};
